import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { showOriginalText, applyChangedLanguage, languageOptions } from "../../../../Navbar/gtUtils";
import Modal from "../../../../UIComponents/CustomModal/Modal";
import { numberWithCommas } from "../utils";

const TranslateWords = (props) => {
    const [selectedLanguage, setSelectedLanguage] = useState({ key: "English", label: "English", value: "en" });

    useEffect(() => {
        translate();
    }, [selectedLanguage]);

    // useEffect(() => {
    //     if (props.open) {
    //         if (sessionStorage.getItem("googleTranslate") !== "false")
    //             setSelectedLanguage(languageOptions.find((l) => l.value === sessionStorage.getItem("selectedLanguage")));
    //         else setSelectedLanguage({ key: "English", label: "English", value: "en" });
    //     } else {
    //         if (sessionStorage.getItem("googleTranslate") !== "false") applyChangedLanguage(sessionStorage.getItem("selectedLanguage"));
    //         else showOriginalText();
    //     }
    // }, [props.open]);

    useEffect(() => {
        if (props.open) {
            if (sessionStorage.getItem("googleTranslate"))
                setSelectedLanguage(languageOptions.find((l) => l.value === sessionStorage.getItem("selectedLanguage")));
            else setSelectedLanguage({ key: "English", label: "English", value: "en" });
        } else {
            if (sessionStorage.getItem("googleTranslate")) applyChangedLanguage(sessionStorage.getItem("selectedLanguage"));
            else showOriginalText();
        }
    }, [props.open]);

    const translate = () => {
        if (selectedLanguage) applyChangedLanguage(selectedLanguage.value);
    };
    //  console.log(props.data);

    const getRows = () => {
        let data = formatData(props.data);

        return data.map((d, i) => (
            <div className="table-row" key={i}>
                {d.map((c, j) => {
                    let className = "";
                    if (j == 0 || j == 2) className = "skiptranslate";
                    return (
                        <span className={className} key={c + j}>
                            {c}
                        </span>
                    );
                })}
            </div>
        ));
    };

    const formatData = (data) => {
        data = data.data;
        let csvObj = {
            columns: [],
        };
        if (!props.showMore) {
            data = data.slice(0, 10);
        }

        // if (props.companyLiteID == 10614) {
        //     console.log("firstdattttta", data);
        //    data.forEach((ele) => {
        //         console.log("firstellle", ele);
        //         if (ele.drilldown[0]?.drilldown) {
        //              ele.drilldown?.forEach((e) => {
        //                 e.drilldown =  e.drilldown?.filter((obj) => {
        //                     return !["ホワイト", "white"].includes(obj.label.toLowerCase() == "white" ? "white" : obj.label);
        //                 });
        //                 console.log("JSONNN",JSON.parse(JSON.stringify(e.drilldown)))
        //             });
        //         } else {
        //             ele.drilldown = ele.drilldown?.filter((obj) => {
        //                 return !["ホワイト", "white"].includes(obj.label.toLowerCase() == "white" ? "white" : obj.label);
        //             });
        //             console.log("JSONNN",JSON.parse(JSON.stringify(ele.drilldown)))
        //         }
        //     });

        // }
        // console.log("firstdattttta1", data);
        let type = props.appliedFilter && props.appliedFilter.clustering_sort_by ? props.appliedFilter.clustering_sort_by : "volume";

        if (type !== "volume") {
            const sorting_val = type === "impact" ? "impact_score" : "traction";

            const sortAndFilterData = (d) => {
                return d
                    .sort((a, b) => {
                        return b[sorting_val] - a[sorting_val];
                    })
                    .filter((a) => a[sorting_val] !== 0)
                    .map((a) => {
                        if (a.drilldown) a.drilldown = sortAndFilterData(a.drilldown);
                        return a;
                    });
            };

            data = sortAndFilterData(data);
        }

        data.forEach((parent, index) => {
            let parent_arr = [];
            parent_arr.push(index + 1);
            parent_arr.push(parent.label);
            parent_arr.push(numberWithCommas(parent.doc_count));
            if (parent.drilldown && parent.drilldown[0])
                if (parent.drilldown[0].drilldown && parent.drilldown[0].drilldown.length > 0) {
                    parent.drilldown.forEach((subcategory, ind) => {
                        let subcategory_arr = [];
                        if (ind === 0) subcategory_arr = parent_arr;
                        else subcategory_arr = ["", "", ""];
                        subcategory.drilldown.forEach((keyword, indx) => {
                            if (indx === 0) {
                                subcategory_arr.push(subcategory.label);
                                subcategory_arr.push(keyword.label);
                                csvObj.columns.push(subcategory_arr);
                            } else {
                                let keyword_arr = [];
                                keyword_arr.push("", "", "", "");
                                keyword_arr.push(keyword.label);
                                csvObj.columns.push(keyword_arr);
                            }
                        });
                    });
                } else {
                    parent.drilldown.forEach((keyword, ind) => {
                        if (ind === 0) {
                            parent_arr.push("");
                            parent_arr.push(keyword.label);
                            csvObj.columns.push(parent_arr);
                        } else {
                            let keyword_arr = [];
                            keyword_arr.push("", "", "", "");
                            keyword_arr.push(keyword.label);
                            csvObj.columns.push(keyword_arr);
                        }
                    });
                }
            else {
                parent_arr.push("", "");
                csvObj.columns.push(parent_arr);
            }
        });
        return csvObj.columns;
    };

    return (
        <Modal className="toptopics-translate-words" show={props.open} onClose={props.onClose} noSkipGTranslate={true}>
            <Modal.Header className="toptopics-translate-words-header">Translate Top Topic Words</Modal.Header>
            <Modal.Content className="toptopics-translate-words-content" noSkipGTranslate={true}>
                <div className="translate-selector skiptranslate">
                    <span>Translate to</span>
                    <ReactSelect
                        options={languageOptions}
                        placeholder="Select Language"
                        isClearable={false}
                        className="translate-dropdown"
                        isSearchable
                        value={selectedLanguage}
                        onChange={setSelectedLanguage}
                    />
                </div>

                <div className="toptopics-words-table">
                    <div className="header table-row skiptranslate">
                        <span className="">No</span>
                        <span className="">Category</span>
                        <span className="">Volume of Posts</span>
                        <span className="">Sub-Categories</span>
                        <span className="">Keywords</span>
                    </div>
                    {props.open && props.data && props.data.data && props.data.data.length && getRows()}
                </div>
            </Modal.Content>
        </Modal>
    );
};

export default TranslateWords;
